import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Delivered = ({
  size,
  type,
  theme,
  className,
  dataTestId = "delivered-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.207 4.293a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414 0l-2.5-2.5a1 1 0 0 1 1.414-1.414L3.5 9.586l5.293-5.293a1 1 0 0 1 1.414 0Zm5.5 0a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414 0l-1-1a1 1 0 0 1 1.414-1.414L9 9.586l5.293-5.293a1 1 0 0 1 1.414 0Z"
    />
  </SVGIcon>
);
